interface PlayerAvatarProps {
  initials: string;
  gradient?: string;
  size?: 'sm' | 'md' | 'lg';
  alt: string;
  className?: string;
  ring?: string;
}

const sizes = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-20 h-20 md:w-24 md:h-24 text-lg',
};

export function PlayerAvatar({
  initials,
  gradient = 'from-primary-container to-surface-container-high',
  size = 'md',
  alt,
  className = '',
  ring = '',
}: PlayerAvatarProps) {
  return (
    <div
      role="img"
      aria-label={alt}
      className={`rounded-full flex items-center justify-center bg-gradient-to-br ${gradient} text-on-primary-container font-label-bold ${sizes[size]} ${ring} ${className}`}
    >
      {initials}
    </div>
  );
}
